import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const createFoodOrder = async (orderData) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/api/food-order/public`, orderData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getFoodOrderByNumber = async (orderNumber) => {
    try {
        const response = await axios.get(`${API_URL}/api/food-order/public/track/${orderNumber}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const searchOrdersByContact = async (searchData) => {
    try {
        const params = new URLSearchParams();
        if (searchData.email) params.append('email', searchData.email);
        if (searchData.phone) params.append('phone', searchData.phone);

        const response = await axios.get(`${API_URL}/api/food-order/public/search?${params}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getUserOrderHistory = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/api/food-order/user/history`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getUserOrders = async (status = null, limit = 20) => {
    try {
        const token = localStorage.getItem('token');
        
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        if (limit) params.append('limit', limit);

        const url = `${API_URL}/api/food-order/user/user?${params}`;

        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const validateCouponCode = async ({ code, subtotal, orderType }) => {
    try {
        const token = localStorage.getItem('token');
        const headers = {
            'Content-Type': 'application/json'
        };
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios.post(`${API_URL}/api/coupons/validate`, {
            code,
            subtotal,
            orderType
        }, {
            headers
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const cancelUserOrder = async (orderId, cancellationReason = 'Cancelled by customer') => {
    try {
        const token = localStorage.getItem('token');
        
        const response = await axios.patch(`${API_URL}/api/food-order/user/${orderId}/cancel`, {
            cancellationReason
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// ============================================================================
// Online payments. These reject with the axios error (use error.response), so
// callers can tell a signed-out customer (4xx) from a server problem.
// ============================================================================

const withCustomerAuth = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

// Payment status of the signed-in customer's own order
export const getOnlinePaymentStatus = (orderNumber) =>
    axios
        .get(`${API_URL}/api/payments/orders/${encodeURIComponent(orderNumber)}`, withCustomerAuth())
        .then((response) => response.data);

// New payment page for an order that is still waiting for payment
export const retryOnlinePayment = (orderNumber, returnPath) =>
    axios
        .post(
            `${API_URL}/api/payments/orders/${encodeURIComponent(orderNumber)}/retry`,
            { returnPath },
            withCustomerAuth()
        )
        .then((response) => response.data);
